import { render, staticRenderFns } from "./AddManuscrit.vue?vue&type=template&id=72a9c295&scoped=true"
import script from "./AddManuscrit.vue?vue&type=script&lang=js"
export * from "./AddManuscrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9c295",
  null
  
)

export default component.exports